function playerMatchesIds(playerLike, ids) {
  if (!playerLike || !ids.length) return false;
  return ids.some(
    (id) =>
      (playerLike.player_id != null && String(playerLike.player_id) === id) ||
      (playerLike.user_id != null && String(playerLike.user_id) === id)
  );
}

export function resolveExercisePlayerById(exerciseContext, playerId) {
  if (!playerId || !exerciseContext) return null;
  const pid = String(playerId);
  const pools = [
    ...(Array.isArray(exerciseContext.players) ? exerciseContext.players : []),
    exerciseContext.player1,
    exerciseContext.player2,
    ...(Array.isArray(exerciseContext.player_details)
      ? exerciseContext.player_details
      : []),
  ].filter(Boolean);

  return (
    pools.find(
      (player) =>
        (player.player_id != null && String(player.player_id) === pid) ||
        (player.user_id != null && String(player.user_id) === pid)
    ) || null
  );
}

function distinctRosterTableNumbers(exerciseContext) {
  const seen = new Set();
  for (const player of exerciseContext?.players || []) {
    const n = Number(player?.table_number);
    if (Number.isFinite(n) && n > 0) seen.add(n);
  }
  return seen;
}

/**
 * Resolve which physical table the viewer played on for exercise results.
 * Prefers per-player tbl_te_player table_number over exercise-level table_number
 * (which is wrong for legacy multi-table TEs and KoT).
 */
export function resolveViewerTableNumber(exerciseContext, playerId, userId) {
  if (!exerciseContext) return null;

  const ids = [playerId, userId].filter(Boolean).map(String);
  const exerciseTable = Number(exerciseContext.table_number);
  const multiTableRoster = distinctRosterTableNumbers(exerciseContext).size > 1;

  if (ids.length === 0) {
    if (Number.isFinite(exerciseTable) && exerciseTable > 0 && !multiTableRoster) {
      return exerciseTable;
    }
    const seqTables = (exerciseContext.sequences || [])
      .map((seq) => Number(seq.table_number))
      .filter((n) => Number.isFinite(n) && n > 0);
    if (seqTables.length === 1) return seqTables[0];
    return null;
  }

  const player = resolveExercisePlayerById(
    exerciseContext,
    playerId || userId
  );
  const playerTable = Number(player?.table_number);
  if (Number.isFinite(playerTable) && playerTable > 0) {
    return playerTable;
  }

  for (const seq of exerciseContext.sequences || []) {
    const tableNum = Number(seq.table_number);
    const slots = [
      [seq.player_a_id, seq.player_a],
      [seq.player_b_id, seq.player_b],
      [seq.player_c_id, seq.player_c],
      [seq.player_d_id, seq.player_d],
    ];
    for (const [wireId, row] of slots) {
      const matched =
        (wireId && ids.some((id) => String(wireId) === id)) ||
        (row && playerMatchesIds(row, ids));
      if (!matched) continue;
      if (Number.isFinite(tableNum) && tableNum > 0) return tableNum;
      break;
    }
  }

  if (!multiTableRoster && Number.isFinite(exerciseTable) && exerciseTable > 0) {
    return exerciseTable;
  }

  return null;
}
